var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-body"},[_c('OpenserveLine',{directives:[{name:"allowed",rawName:"v-allowed:view",value:(['STAFF', 'CLIENT', 'RESELLER', 'SYSTEM']),expression:"['STAFF', 'CLIENT', 'RESELLER', 'SYSTEM']",arg:"view"}],attrs:{"line":_vm.saleDefinition.definition.line}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }